export class ApiResult {
  id: string;
  value: string;
  status: string;
}
